module.exports = __webpack_public_path__ + "img/cross.f41302c2.svg";